import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { HiOutlineZoomIn, HiZoomOut } from 'react-icons/hi';
import Button from '../Button';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();
export default function PDFView({ file }) {
  const [pagesQty, setPagesQty] = useState(0);
  const [zoomInOut, setZoomInOut] = useState(1);

  function onDocumentLoadSuccess(data) {
    setPagesQty(data.numPages);
  }

  const zoomIncremet = () => {
    setZoomInOut((prev) => Math.min(prev + 0.2, 3));
  };

  const zoomDecremet = () => {
    setZoomInOut((prev) => Math.max(prev - 0.2, 0.6));
  };

  return (
    <Document
      style={{ width: '100%' }}
      file={file}
      onLoadError={console.log}
      onLoadSuccess={onDocumentLoadSuccess}
      onSourceError={console.log}
    >
      <div style={{ display: 'flex', gap: 12, margin: '12px 20px', alignItems: 'center' }}>
        <Button
          size="sm"
          style={{ width: 'auto', display: 'inline-flex', alignItems: 'center', gap: 6 }}
          onClick={() => zoomIncremet()}
        >
          Zoom In
          <HiOutlineZoomIn size={20} />
        </Button>

        <Button
          size="sm"
          style={{ width: 'auto', display: 'inline-flex', alignItems: 'center', gap: 6 }}
          onClick={() => zoomDecremet()}
        >
          Zoom Out
          <HiZoomOut size={20} />
        </Button>
      </div>
      {Array.from(new Array(pagesQty), (el, index) => (
        <Page scale={zoomInOut} key={`page_${index + 1}`} pageNumber={index + 1} />
      ))}
    </Document>
  );
}
